// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"870":"29156110","877":"dad108b6"}[chunkId] + ".chunk.js";
};